import Swiper from "swiper";
import { addToGlobalThisRet } from "@plugins";

import {
    selectionDefaultBreakpoints,
    selectionNarrowBreakpoints,
    accessoriesDefaultBreakpoints,
    accessoriesNarrowBreakpoints,
} from "./selection-breakpoints";

class Selection {
    constructor(selection) {
        this.selection = selection;
        this.sliderContainer = this.selection.querySelector(".js-selection-slider");
        this.controls = [];

        this._init();
    }

    _init() {
        this._choseBreakpoints();
        this._findControls();
        this._choseBullets();
        this._initSlider();
    }

    _findControls() {
        this.controls = {
            buttonPrev: this.selection.querySelector(".swiper-button-prev"),
            buttonNext: this.selection.querySelector(".swiper-button-next"),
            pagination: this.selection.querySelector(".js-swiper-pagination"),
        };
    }

    _choseBreakpoints() {
        switch (true) {
            case this.selection.classList.contains("js-selection-narrow"):
                this.breakpoints = selectionNarrowBreakpoints;
                break;
            case this.selection.classList.contains("js-selection-accessories"):
                this.breakpoints = accessoriesDefaultBreakpoints;
                break;
            case this.selection.classList.contains("js-selection-accessories-narrow"):
                this.breakpoints = accessoriesNarrowBreakpoints;
                break;
            default:
                this.breakpoints = selectionDefaultBreakpoints;
        }
    }

    _choseBullets() {
        if (this.controls.pagination.hasAttribute("data-dynamic-bullets") || window.mobileMedia) {
            this.dynamicBullets = true;
        } else {
            this.dynamicBullets = false;
        }
    }

    _initSlider() {
        const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 17,
            preventClicks: false,
            pagination: {
                el: this.controls.pagination,
                dynamicBullets: this.dynamicBullets,
                dynamicMainBullets: 3,
                clickable: true,
            },
            navigation: {
                prevEl: this.controls.buttonPrev,
                nextEl: this.controls.buttonNext,
            },
            observer: true,
            observeParents: true,
            watchOverflow: true,

            breakpoints: this.breakpoints,
        };

        this.slider = new Swiper(this.sliderContainer, swiperOptions);
    }
}

function initSelections() {
    const selections = document.querySelectorAll(".js-selection");

    if (selections) {
        for (const selection of selections) {
            initSelectionsIntersectionObserver(selection);
        }
    }
}

function initSelectionsIntersectionObserver(selection) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    new Selection(selection);
                    observer.unobserve(selection);
                }
            });
        },
        {
            rootMargin: "0px 0px 250px 0px",
            threshold: 0,
        },
    );

    observer.observe(selection);
}

initSelections();
addToGlobalThisRet(initSelections, "initSelections");
